import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import S from './StyledNavigation';
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { Link } from "gatsby";

var classNames = require('classnames');

const Navigation = (props) => {

    const navClasses = classNames({
        'small-navigation' : props.isTop === false,
        'mobile-menu' : props.isOpen === true
    })

    return (
        <S.Navigation className={navClasses}>
            <ul>
                <li><AniLink fade to="/nadzor-budowlany-realizacje-zachodniopomorskie/" className="menu-item" activeClassName="active">Realizacje</AniLink></li>
                <li><Link fade to="/#oferta" className="menu-item" activeClassName="active">Oferta</Link></li>
                <li><AniLink fade to="/firma-nda/" className="menu-item" activeClassName="active">Firma NDA</AniLink></li>
                <li><AniLink fade to="/kierownik-budowy-zachodniopomorskie/" className="menu-item" activeClassName="active">Kierownik budowy</AniLink></li>
                {/* <li><AniLink fade to="/inspektor-nadzoru-inwestorskiego/" className="menu-item" activeClassName="active">Inspektor nadzoru inwestorskiego</AniLink></li> */}
                <li><AniLink fade to="/przeglad-okresowy-budynkow/" className="menu-item" activeClassName="active">Przegląd okresowy budynków</AniLink></li>
                <li><AniLink fade to="/kontakt/" className="menu-item" activeClassName="active">Kontakt</AniLink></li>
                <li><a className='icon phone' href="tel:+48723902000" rel="noopener noreferrer"><FontAwesomeIcon icon={faPhoneAlt}/>723 90 2000</a></li>
                <div className="icons-wrapper">
                    <li><a className='icon facebook' href="#" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebook}/></a></li>
                    <li><a className='icon instagram' href="#" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram}/></a></li>
                </div>
            </ul>
        </S.Navigation>
        )
    }

export default Navigation
